import { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import API from '../../Common/API';
import { useDispatch, useSelector } from 'react-redux';
import HomePageLoader from '../../Components/Loaders/HomePageLoader';
import { useHistory } from 'react-router-dom';
import { LuIndianRupee } from 'react-icons/lu';
import { LiaFilterSolid } from 'react-icons/lia';
import { BsBookmarkHeart, BsBookmarkHeartFill, BsFillFilterSquareFill } from 'react-icons/bs';
import axios from 'axios';
import noProduct from '../../Assets/Images/noProd.jpg';
import { useTranslation } from 'react-i18next';
import { TbShoppingBagPlus } from 'react-icons/tb';
import { setAlert } from '../../Store/Theme/actions';

const Shopping = ({ match }) => {
    const [loading, setLoading] = useState(true);
    const [products, setProducts] = useState([]);
    const userDetails = useSelector((state) => state.auth.userDetails);
    const isLoggedIn = useSelector((state) => state.auth.isLoggedIn);
    const history = useHistory();
    const [categories, setCategories] = useState([]);
    const [minPrice, setMinPrice] = useState(0);
    const [maxPrice, setMaxPrice] = useState(0);
    const [filterIds, setFilterIds] = useState([]);
    const [callAgain, setCallAgain] = useState(0);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [lowToHigh, setLowToHigh] = useState(false);
    const lang =
        useSelector((state) => state.theme.language) === localStorage.getItem('i18nextLng')
            ? localStorage.getItem('i18nextLng')
            : 'en';
    const { t } = useTranslation();
    const dispatch = useDispatch();

    useEffect(() => {
        try {
            if (match.params.categoryId && match.params.subCategoryId) {
                axios
                    .all([
                        API.get(
                            `/category/getSubCategories?categoryId=${match.params.categoryId}&subCategoryId=${match.params.subCategoryId}`
                        ),
                        API.get(
                            `/products/getProductByCategory?page=1&limit=20&categoryId=${
                                match.params.categoryId
                            }&subCategoryId=${
                                match.params.subCategoryId
                            }&lowToHigh=${lowToHigh}&userId=${
                                userDetails.subject ? userDetails.subject._id : null
                            }`
                        ),
                    ])
                    .then(
                        axios.spread((comRes, proRes) => {
                            setProducts(proRes.data.data);
                            setCategories(comRes.data.data);
                            setFilterIds([match.params.subCategoryId]);
                            setLoading(false);
                        })
                    );
            } else if (match.params.categoryId) {
                axios
                    .all([
                        API.get(`/category/getSubCategories?categoryId=${match.params.categoryId}`),
                        API.get(
                            `/products/getProductByCategory?page=1&limit=20&categoryId=${
                                match.params.categoryId
                            }&lowToHigh=${lowToHigh}&userId=${
                                userDetails.subject ? userDetails.subject._id : null
                            }`
                        ),
                    ])
                    .then(
                        axios.spread((comRes, proRes) => {
                            setProducts(proRes.data.data);
                            setCategories(comRes.data.data);
                            setLoading(false);
                        })
                    );
            } else if (match.params.priceType) {
                axios
                    .all([
                        API.get(
                            `/products/getProductsByPriceType?page=1&limit=20&priceType=${
                                match.params.priceType
                            }&lowToHigh=${lowToHigh}&userId=${
                                userDetails.subject ? userDetails.subject._id : null
                            }`
                        ),
                    ])
                    .then(
                        axios.spread((proRes) => {
                            setProducts(proRes.data.data);
                            setLoading(false);
                        })
                    );
            }
        } catch (err) {
            throw err;
        }
    }, [match.params.categoryId, match.params.priceType, callAgain, match.params.subCategoryId]);

    const viewProduct = (value) => {
        history.push(`/product/${value._id}/view`);
    };

    const wishList = (value) => {
        let apiValues = {
            productId: value._id,
            addedBy: userDetails.subject._id,
        };
        API.post('/products/wishList', apiValues).then((wishRes) => {
            if (wishRes.status === 200) {
                setProducts(
                    products.map((c) => {
                        if (c._id === wishRes.data.data.productId) {
                            c.wishList = [wishRes.data.data];
                        }
                        return c;
                    })
                );
            }
        });
    };

    const clearAllFilters = () => {
        setMinPrice(0);
        setMaxPrice(0);
        setLowToHigh(false);
        setFilterIds([]);
        setCallAgain(callAgain + 1);
    };

    const applyFilterValue = () => {
        API.get(
            `/products/getFilteredProducts?page=1&limit=20&min=${minPrice}&max=${maxPrice}&lowToHigh=${lowToHigh}&categoryId=${
                match.params.categoryId
            }&subCategoryIds=${filterIds}&userId=${
                userDetails.subject ? userDetails.subject._id : null
            }`
        ).then((proRes) => {
            setProducts(proRes.data.data);
        });
    };

    const addOrRemoveId = (value) => {
        setFilterIds((prevIds) => {
            // Check if the value already exists in the array
            if (prevIds.includes(value)) {
                // If it exists, remove it by filtering it out
                return prevIds.filter((id) => id !== value);
            } else {
                // If it doesn't exist, add it to the array
                return [...prevIds, value];
            }
        });
    };

    const addToCart = (productId) => {
        let values = {
            productId: productId,
            userOderQuantity: 1,
            addedBy: userDetails.subject._id,
        };
        API.post('/products/addToCart', values).then((cartRes) => {
            if (cartRes.status === 200) {
                dispatch(
                    setAlert({
                        type: 'success',
                        title: 'Success',
                        subtitle: 'Product added to the cart',
                        active: true,
                    })
                );
                // setCount(count + 1);
                setCallAgain(callAgain + 1);
            }
        });
    };
    return (
        <motion.div className="w-full h-full relative flex gap-10 flex-col md:flex-row px-2">
            <motion.div
                className="text-black px-2 justify-end flex flex-row  cursor-pointer block md:hidden"
                onClick={() => setIsMenuOpen(!isMenuOpen)}
            >
                {isMenuOpen ? (
                    <span className="text-3xl">&#x2715; {/* Close Icon */}</span>
                ) : (
                    <BsFillFilterSquareFill className="text-3xl" />
                )}
            </motion.div>
            {isMenuOpen && (
                <motion.div className="flex flex-col px-2 py-2">
                    <motion.div className="w-full flex flex-col my-2">
                        <motion.div className="text-md font-bold">{t('Min')}</motion.div>
                        <input
                            type="number"
                            className="ring-1 ring-[grey] px-2 rounded"
                            min={0}
                            max={1000000}
                            value={minPrice}
                            onChange={(ev) => setMinPrice(ev.target.value)}
                        />
                    </motion.div>
                    <motion.div className="w-full flex flex-col my-2">
                        <motion.div className="text-md font-bold">{t('Max')}</motion.div>
                        <input
                            type="number"
                            className="ring-1 ring-[grey] px-2 rounded"
                            min={0}
                            max={1000000}
                            value={maxPrice}
                            onChange={(ev) => setMaxPrice(ev.target.value)}
                        />
                    </motion.div>
                    <motion.div className="w-full flex flex-col my-5">
                        {t('Sub Categories')}
                        <motion.div className="my-2">
                            {categories.map((cat) => {
                                return (
                                    <motion.div className="flex flex-row items-center">
                                        <input
                                            type="checkbox"
                                            checked={filterIds.includes(cat._id)}
                                            className="mx-2"
                                            onClick={() => addOrRemoveId(cat._id)}
                                        />
                                        {lang === 'en' ? cat.subCategory : cat.subCategoryTamil}
                                    </motion.div>
                                );
                            })}
                        </motion.div>
                    </motion.div>
                    <motion.div className="w-full flex flex-col justify-between">
                        <motion.div
                            className="bg-white ring-1 cursor-pointer my-2 text-black ring-[gray] rounded-full flex flex-row items-center justify-center"
                            onClick={() => clearAllFilters()}
                        >
                            {t('Clear Filter')}
                        </motion.div>
                        <motion.div
                            className="bg-black text-white my-2 ring-1 cursor-pointer ring-[black] rounded-full flex flex-row items-center justify-center"
                            onClick={() => applyFilterValue()}
                        >
                            {t('Apply Filter')}
                        </motion.div>
                    </motion.div>
                </motion.div>
            )}
            <motion.div className="w-60 md:block hidden h-full flex flex-col text-sm px-2">
                <motion.div className="text-2xl font-bold flex gap-5 items-center flex-row justify-center">
                    <motion.div className="flex flex-col items-center text-center justify-center h-10 w-10 rounded-full my-2 bg-[lightGray]">
                        <LiaFilterSolid className="text-lg" size={24} />
                    </motion.div>
                    {t('Filters')}
                </motion.div>
                <motion.div className="w-full flex flex-col my-5">
                    {t('Sub Categories')}
                    <motion.div className="my-2">
                        {categories.map((cat) => {
                            return (
                                <motion.div className="flex flex-row items-center">
                                    <input
                                        type="checkbox"
                                        checked={filterIds.includes(cat._id)}
                                        className="mx-2"
                                        onClick={() => addOrRemoveId(cat._id)}
                                    />
                                    {lang === 'en' ? cat.subCategory : cat.subCategoryTamil}
                                </motion.div>
                            );
                        })}
                    </motion.div>
                </motion.div>
                <motion.div className="w-full flex flex-col my-5">
                    {t('Price')}
                    <motion.div className="w-full flex flex-col my-2">
                        <motion.div className="text-md font-bold">{t('Min')}</motion.div>
                        <input
                            type="number"
                            className="ring-1 ring-[grey] px-2 rounded"
                            min={0}
                            max={1000000}
                            value={minPrice}
                            onChange={(ev) => setMinPrice(ev.target.value)}
                        />
                        {minPrice > maxPrice ? (
                            <p className="text-xs text-[red]">
                                Min price should be lesser than max price
                            </p>
                        ) : (
                            ''
                        )}
                    </motion.div>
                    <motion.div className="w-full flex flex-col my-2">
                        <motion.div className="text-md font-bold">{t('Max')}</motion.div>
                        <input
                            type="number"
                            className="ring-1 ring-[grey] px-2 rounded"
                            min={0}
                            max={1000000}
                            value={maxPrice}
                            onChange={(ev) => setMaxPrice(ev.target.value)}
                        />
                        {maxPrice < minPrice ? (
                            <p className="text-xs text-[red]">
                                Max price should be greater than min price
                            </p>
                        ) : (
                            ''
                        )}
                    </motion.div>
                </motion.div>
                <motion.div className="w-full flex flex-col justify-between">
                    <motion.div
                        className="bg-white ring-1 cursor-pointer my-2 text-black ring-[gray] rounded-full flex flex-row items-center justify-center"
                        onClick={() => clearAllFilters()}
                    >
                        {t('Clear Filter')}
                    </motion.div>
                    <motion.div
                        className={`my-2 ring-1 ${
                            !(minPrice > maxPrice && maxPrice < minPrice)
                                ? 'cursor-pointer bg-black text-white '
                                : 'cursor-not-allowed bg-[lightGrey] text-black'
                        } ring-[black] rounded-full flex flex-row items-center justify-center`}
                        onClick={() =>
                            !(minPrice > maxPrice && maxPrice < minPrice) && applyFilterValue()
                        }
                    >
                        {t('Apply Filter')}
                    </motion.div>
                </motion.div>
            </motion.div>
            <div className="hidden md:block w-px bg-gray-300 my-4" />
            {loading ? (
                <HomePageLoader />
            ) : products && products.length > 0 ? (
                <motion.div className="flex flex-col w-full gap-5 h-full px-5">
                    <motion.div className="flex flex-row w-full justify-between">
                        <p className="text-lg">
                            <span className="font-bold">Product List</span>{' '}
                            <span className="text-[grey]">({products.length})</span>
                        </p>
                    </motion.div>
                    <motion.div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-4 gap-3">
                        {products &&
                            products.map((pro, i) => {
                                return (
                                    <motion.div
                                        key={i}
                                        className="relative flex flex-col bg-white cursor-pointer shadow-md rounded-lg h-[380px]"
                                    >
                                        <motion.div
                                            className="absolute top-3 right-3 text-xl z-10"
                                            onClick={() => wishList(pro)}
                                        >
                                            {pro.wishList.length > 0 &&
                                            pro.wishList[0].activeStat === 'A' ? (
                                                <BsBookmarkHeartFill />
                                            ) : (
                                                <BsBookmarkHeart />
                                            )}
                                        </motion.div>
                                        <motion.div
                                            className="h-48 flex items-center justify-center p-2"
                                            onClick={() => viewProduct(pro)}
                                        >
                                            <img
                                                src={pro.images[0]?.imageUrl}
                                                className="h-full w-full object-contain"
                                                alt="preview"
                                            />
                                        </motion.div>
                                        <motion.div className="flex flex-col flex-1 justify-between p-3">
                                            <motion.div
                                                className="text-sm font-medium line-clamp-2 cursor-pointer"
                                                onClick={() => viewProduct(pro)}
                                            >
                                                {pro.productName}{' '}
                                                {pro.brandName && `/ ${pro.brandName}`}
                                            </motion.div>
                                            <motion.div
                                                className="flex items-center font-bold text-lg mt-1"
                                                onClick={() => viewProduct(pro)}
                                            >
                                                <LuIndianRupee />
                                                {pro.offerPercentage === 0
                                                    ? pro.price
                                                    : Math.round(
                                                          pro.price * (pro.offerPercentage / 100)
                                                      )}
                                            </motion.div>
                                            <motion.div className="mt-3">
                                                <motion.div
                                                    className="flex items-center justify-center gap-2 w-full h-10 rounded-lg bg-gray-200 hover:bg-primeColor hover:text-white hover:font-bold transition"
                                                    onClick={(e) => {
                                                        e.stopPropagation();
                                                        isLoggedIn
                                                            ? addToCart(pro._id)
                                                            : history.push('/auth/login');
                                                    }}
                                                >
                                                    <TbShoppingBagPlus /> Add to cart
                                                </motion.div>
                                            </motion.div>
                                        </motion.div>
                                    </motion.div>
                                );
                            })}{' '}
                        :
                    </motion.div>
                </motion.div>
            ) : (
                <motion.div className="h-full w-full justify-center items-center flex flex-col">
                    <img src={noProduct} alt="No products" width={500} />
                    <p className="text-black font-bold">
                        {t('OOPS!!... No products at this moment')}
                    </p>
                </motion.div>
            )}
        </motion.div>
    );
};

export default Shopping;
